import {Button} from "inferno-bootstrap";
import X from "inferno-feather/dist/icons/x";
import {Tooltip} from "../Tooltip";
import {Configuration} from "../../services/configuration";

export function Close(props: { onClose: (event: MouseEvent) => void }) {
	return (
		<Button color="primary" onClick={props.onClose}>
			<X id="x-btn"/>
			{ !Configuration.isMobile ? <Tooltip target="x-btn" content="VCC_XTOL_HEADER_CLOSE_TOOLTIP"/> : null }
		</Button>
	);
}
